import Cookies from "js-cookie";

// cookie 관련 hook
const useCookie = () => {
  const setCookie = (cookieKey: string, value: any, expires: number = 7) => {
    //expires에 -1을 넣으면 영원히 유지되게끔
    if (expires == -1) {
      Cookies.set(cookieKey, value.toString(), { expires: 3650 }); //10년 동안 유지
    } else {
      Cookies.set(cookieKey, value.toString(), { expires }); //after 7 days, expire
    }
  };

  const getCookie = (cookieKey: string) => {
    const cookieValue = Cookies.get(cookieKey);
    return cookieValue;
  };

  const deleteCookie = (cookieKey: string) => {
    Cookies.remove(cookieKey);
  };

  return { setCookie, getCookie, deleteCookie };
};

export default useCookie;
